module.exports = __webpack_public_path__ + "d8e030e45a54d15eeacbbcfa26ab7abd.svg";